import { useMemo } from 'react'
import { useTheme } from 'styled-components'
import { ColorVariant } from 'styling/GlobalStyles'
import { OptionsProps, Table } from 'components/Table/Table'
import { Badge } from 'components/Badge/Badge'
import { MediumText, NormalText } from 'styling/TypographyV2'
import { PanelContainer, PanelTitle } from '../Organogram.styled'

interface IAuditLogEntry {
  id: number
  timestamp: string
  actor: string
  action: string
  entity: string
  details: string
}

const AUDIT_LOG: IAuditLogEntry[] = [
  {
    id: 1,
    timestamp: '09/06/2026 14:32',
    actor: 'Sarah Chen',
    action: 'Assignment created',
    entity: 'Haulage Alpha',
    details: 'Assigned James Mitchell to team',
  },
  {
    id: 2,
    timestamp: '09/06/2026 11:15',
    actor: 'David Okafor',
    action: 'Team updated',
    entity: 'North Pit Crew',
    details: 'Changed supervisor escalation chain',
  },
  {
    id: 3,
    timestamp: '08/06/2026 16:48',
    actor: 'Marcus Owen',
    action: 'Team created',
    entity: 'Processing Night Shift',
    details: 'Created operational team at Processing Plant',
  },
  {
    id: 4,
    timestamp: '08/06/2026 09:20',
    actor: 'Sarah Chen',
    action: 'Assignment ended',
    entity: 'Mining Ops Day',
    details: 'Ended assignment for Ethan Walker',
  },
  {
    id: 5,
    timestamp: '07/06/2026 18:05',
    actor: 'System',
    action: 'Bulk assign',
    entity: 'Maintenance Crew B',
    details: '4 employees assigned via bulk wizard',
  },
]

export const AuditLogTab = () => {
  const theme = useTheme() as any

  const tableOptions = useMemo<OptionsProps<IAuditLogEntry>[]>(
    () => [
      { header: 'Timestamp', cell: (row) => row.timestamp },
      { header: 'Actor', cell: (row) => row.actor },
      {
        header: 'Action',
        cell: (row) => (
          <Badge hexColor={theme.colorOrange}>{row.action}</Badge>
        ),
      },
      { header: 'Entity', cell: (row) => row.entity },
      { header: 'Details', cell: (row) => row.details },
    ],
    [theme.colorOrange],
  )

  return (
    <PanelContainer>
      <PanelTitle>Audit Log</PanelTitle>
      <NormalText colorVariant={ColorVariant.SECONDARY}>
        Recent operational structure changes across teams and assignments.
      </NormalText>
      <MediumText bold colorVariant={ColorVariant.BASE} style={{ marginTop: '1rem' }}>
        Last 30 days
      </MediumText>
      <Table<IAuditLogEntry>
        cellKey='id'
        items={AUDIT_LOG}
        emptyListOptions={{ title: 'No audit entries.' }}
        options={tableOptions}
      />
    </PanelContainer>
  )
}
